// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b1FWSEpw{font-size:20px;font-weight:600;margin-bottom:20px}\n", "",{"version":3,"sources":["webpack://./src/teachers/teacherMediaRecordings.scss"],"names":[],"mappings":"AAAA,UACE,cAAe,CACf,eAAgB,CAChB,kBAAmB","sourcesContent":[".header {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "b1FWSEpw"
};
export default ___CSS_LOADER_EXPORT___;
